function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var WithdrawTemplate = require('./withdraw.template');
var SaitoOverlay = require('./../../saito-overlay/saito-overlay');
var SaitoContacts = require('./../../modals/saito-contacts/saito-contacts');
var SaitoNFT = require('../../saito-nft/saito-nft');
var SaitoUser = require('./../../saito-user/saito-user');
var WRAPPED_SAITO_TICKERS = ['ERC-SAITO', 'BEP-SAITO'];
var QUERY_GATED_TICKERS = new Set(['BEP-SAITO']);
var Withdraw = /*#__PURE__*/function () {
  function Withdraw(app, mod) {
    var _this = this;
    var container = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    _classCallCheck(this, Withdraw);
    this.app = app;
    this.mod = mod;
    this.container = container;
    this.overlay = new SaitoOverlay(this.app, this.mod);
    this.contacts = new SaitoContacts(app, mod);
    this.counterparty = new SaitoUser(app, mod, '#withdrawal-form .withdraw-confirm-counterparty');
    this.ticker = '';
    this.pc = null;
    this.publicKey = '';
    this.fixedRecipient = false;
    this.address = '';
    this.recipientAddressValid = false;
    this.fee = null;
    this.feeAssetId = '';
    this.feeTicker = '';
    this.feeAssetBalance = null;
    this.feePending = false;
    this.feeRequestKey = '';
    this.feeRequestPromise = null;
    this.lastTxHash = '';
    this.amountErrorMessage = '';
    this.errors = {
      amount: false,
      address: false
    };
    this.available_balance = 0;
    this._nft_balance_raw = null;
    this.app.connection.on('saito-crypto-withdraw-render-request', /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(obj) {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _this.ticker = (obj === null || obj === void 0 ? void 0 : obj.ticker) || '';
              _this.publicKey = (obj === null || obj === void 0 ? void 0 : obj.address) || '';
              _this.fixedRecipient = Boolean(_this.publicKey && _this.app.crypto.isPublicKey(_this.publicKey));
              if (!_this.ticker) {
                _context.n = 1;
                break;
              }
              _context.n = 1;
              return _this.app.wallet.setPreferredCrypto(_this.ticker);
            case 1:
              _this.render();
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
  }
  return _createClass(Withdraw, [{
    key: "render",
    value: function () {
      var _render = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _this2 = this;
        var _document$getElementB;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              this.closeTokenMenu();
              this.pc = this.app.wallet.returnPreferredCrypto();
              this.ticker = this.pc.ticker;
              this.amountErrorMessage = '';
              this.recipientAddressValid = false;
              if (!this.publicKey) {
                _context2.n = 2;
                break;
              }
              _context2.n = 1;
              return this.pc.returnAddressFromPublicKey(this.publicKey);
            case 1:
              this.address = _context2.v;
            case 2:
              if (document.getElementById('withdrawal-form')) {
                this.app.browser.replaceElementById(WithdrawTemplate(this.app, this.mod, this.publicKey, this.address, this.fixedRecipient), 'withdrawal-form');
              } else {
                this.overlay.show(WithdrawTemplate(this.app, this.mod, this.publicKey, this.address, this.fixedRecipient), function () {
                  _this2.clear();
                });
              }
              _context2.n = 3;
              return this.loadCryptos();
            case 3:
              _context2.n = 4;
              return this.refreshAvailableBalanceDisplay();
            case 4:
              this.updateComposeLabels();
              document.querySelectorAll("#withdraw-logo-cont img[data-ticker=\"".concat(this.pc.ticker, "\"]")).forEach(function (el) {
                return el.classList.remove('hide-element');
              });
              _context2.n = 5;
              return this.fetchWithdrawFee();
            case 5:
              this.setWithdrawStep('compose');
              this.setWithdrawState('review');
              this.updateHeaderTitle();
              this.updateHeaderLogos();
              this.attachEvents();
              _context2.n = 6;
              return this.updateAddressUiFromInput({
                fetchFee: false
              });
            case 6:
              this.updateAmountActionState();
              this.updateSuccessAction();
              this.handleErrors();
              if (!this.fixedRecipient) {
                (_document$getElementB = document.getElementById('withdraw-input-address')) === null || _document$getElementB === void 0 || _document$getElementB.focus();
              }
            case 7:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function render() {
        return _render.apply(this, arguments);
      }
      return render;
    }()
  }, {
    key: "updateHeaderTitle",
    value: function updateHeaderTitle() {
      var title = document.getElementById('withdraw-overlay-title');
      if (title) {
        title.textContent = 'SEND CRYPTO';
      }
    }
  }, {
    key: "updateHeaderLogos",
    value: function updateHeaderLogos() {
      var _this$pc, _this$pc2;
      var cont = document.getElementById('withdraw-header-logo-cont');
      if (!cont || !this.pc) {
        return;
      }

      // This overlay is used for multiple assets, but the Admin request is
      // specific: remove the SAITO logo from the titlebar.
      var isSaito = ((_this$pc = this.pc) === null || _this$pc === void 0 ? void 0 : _this$pc.ticker) === 'SAITO' || ((_this$pc2 = this.pc) === null || _this$pc2 === void 0 ? void 0 : _this$pc2.chain_id) === 'NATIVE';
      if (isSaito) {
        cont.classList.add('hide-element');
        cont.innerHTML = '';
        return;
      }
      cont.classList.remove('hide-element');
      var icons = this.pc.returnLogos();
      var html = "<img class=\"crypto-logo\" src=\"".concat(icons.img, "\" alt=\"\" />");
      if (icons.sub_logo) {
        html += "<img class=\"chain-logo\" src=\"".concat(icons.sub_logo, "\" alt=\"\" />");
      }
      cont.innerHTML = html;
    }
  }, {
    key: "updateComposeLabels",
    value: function updateComposeLabels() {
      var amountLabel = document.getElementById('withdraw-amount-label');
      var amountInput = document.getElementById('withdraw-input-amount');
      if (!amountLabel || !amountInput) {
        return;
      }
      if (this.isNftWithdrawSelection()) {
        amountLabel.textContent = 'units';
        amountInput.inputMode = 'numeric';
      } else {
        amountLabel.textContent = 'amount';
        amountInput.inputMode = 'decimal';
      }
    }
  }, {
    key: "getAmountMaxFractionDigits",
    value: function getAmountMaxFractionDigits() {
      return this.isNftWithdrawSelection() ? 0 : 8;
    }
  }, {
    key: "normalizeAmountInput",
    value: function normalizeAmountInput() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var input = document.getElementById('withdraw-input-amount');
      return this.app.browser.formatLocaleAmountInputElement(input, {
        maxFractionDigits: this.getAmountMaxFractionDigits(),
        strictLocaleSeparators: options.strictLocaleSeparators !== false
      });
    }
  }, {
    key: "getAmountInputValue",
    value: function getAmountInputValue() {
      var input = document.getElementById('withdraw-input-amount');
      if (!input) {
        return '';
      }
      var parsed = this.app.browser.parseLocaleAmount(input.value, {
        maxFractionDigits: this.getAmountMaxFractionDigits(),
        strictLocaleSeparators: true
      });
      return parsed.valid ? parsed.normalized : '';
    }
  }, {
    key: "getAmountInputDisplayValue",
    value: function getAmountInputDisplayValue() {
      var input = document.getElementById('withdraw-input-amount');
      if (!input) {
        return '';
      }
      var value = this.getAmountInputValue();
      return value ? this.app.browser.formatLocaleAmount(value, {
        maxFractionDigits: this.getAmountMaxFractionDigits(),
        strictLocaleSeparators: false
      }) : input.value;
    }
  }, {
    key: "setAmountInputValue",
    value: function setAmountInputValue() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var input = document.getElementById('withdraw-input-amount');
      if (!input) {
        return;
      }
      input.value = String(value);
      this.normalizeAmountInput({
        strictLocaleSeparators: false
      });
      this.resetAmountValidation();
    }
  }, {
    key: "hasAmountInputValue",
    value: function hasAmountInputValue() {
      return this.getAmountInputValue() !== '';
    }
  }, {
    key: "resetAmountValidation",
    value: function resetAmountValidation() {
      this.clearAmountError();
      this.updateAmountActionState();
      this.handleErrors();
    }
  }, {
    key: "updateAmountActionState",
    value: function updateAmountActionState() {
      var _amountInput$value;
      var amountInput = document.getElementById('withdraw-input-amount');
      var hasAmount = Boolean(amountInput === null || amountInput === void 0 || (_amountInput$value = amountInput.value) === null || _amountInput$value === void 0 ? void 0 : _amountInput$value.trim());
      var hasValidAmount = hasAmount && this.hasAmountInputValue() && this.errors['amount'] === false;
      var hasInvalidAmount = hasAmount && !hasValidAmount;
      var maxBtn = document.getElementById('withdraw-max-btn');
      var status = document.getElementById('withdraw-amount-status');
      var tooltip = document.getElementById('withdraw-amount-tooltip');
      maxBtn === null || maxBtn === void 0 || maxBtn.classList.toggle('hide-element', hasAmount);
      if (status) {
        var icon = status.querySelector('i');
        status.classList.toggle('hide-element', !hasAmount);
        status.classList.toggle('withdraw-amount-status--valid', hasValidAmount);
        status.classList.toggle('withdraw-amount-status--invalid', hasInvalidAmount);
        status.tabIndex = hasInvalidAmount ? 0 : -1;
        status.setAttribute('aria-label', hasInvalidAmount ? this.amountErrorMessage : hasValidAmount ? 'Amount can be sent' : '');
        if (hasInvalidAmount) {
          status.setAttribute('aria-describedby', 'withdraw-amount-tooltip');
        } else {
          status.removeAttribute('aria-describedby');
        }
        if (icon) {
          icon.className = hasInvalidAmount ? 'fa-solid fa-xmark' : 'fa-solid fa-check';
        }
      }
      if (amountInput) {
        amountInput.setAttribute('aria-invalid', hasInvalidAmount ? 'true' : 'false');
        if (hasInvalidAmount) {
          amountInput.setAttribute('aria-describedby', 'withdraw-amount-tooltip');
        } else {
          amountInput.removeAttribute('aria-describedby');
        }
      }
      if (tooltip) {
        tooltip.textContent = hasInvalidAmount ? this.amountErrorMessage : '';
      }
    }
  }, {
    key: "isNativeSaitoSelection",
    value: function isNativeSaitoSelection() {
      var _this$pc3;
      return ((_this$pc3 = this.pc) === null || _this$pc3 === void 0 ? void 0 : _this$pc3.chain_id) === 'NATIVE';
    }
  }, {
    key: "setUsernameSearchSpinner",
    value: function setUsernameSearchSpinner(on) {
      var book = document.getElementById('address-book');
      if (!book) {
        return;
      }
      book.innerHTML = on ? '<i class="fa-solid fa-spinner fa-spin" aria-hidden="true"></i>' : '<i class="fa-solid fa-users" aria-hidden="true"></i>';
    }
  }, {
    key: "escapeHTML",
    value: function escapeHTML() {
      var _this$app;
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return (_this$app = this.app) !== null && _this$app !== void 0 && (_this$app = _this$app.browser) !== null && _this$app !== void 0 && _this$app.escapeHTML ? this.app.browser.escapeHTML(String(value)) : String(value);
    }
  }, {
    key: "returnRegisteredIdentifier",
    value: function returnRegisteredIdentifier() {
      var publicKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var identifier = this.app.keychain.returnIdentifierByPublicKey(publicKey);
      return identifier && identifier !== publicKey ? identifier : '';
    }
  }, {
    key: "isFixedRecipientForm",
    value: function isFixedRecipientForm() {
      var form = document.getElementById('withdrawal-form');
      if (form) {
        return form.dataset.fixedRecipient === 'true';
      }
      return this.fixedRecipient;
    }
  }, {
    key: "renderSaitoRecipientPreview",
    value: function renderSaitoRecipientPreview() {
      var publicKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var preview = document.getElementById('withdraw-address-preview');
      if (!preview || !publicKey) {
        return;
      }
      var identifier = this.returnRegisteredIdentifier(publicKey);
      var primary = identifier || publicKey;
      var secondary = identifier ? publicKey : 'anonymous user';
      var identicon = this.app.keychain.returnIdenticon(publicKey);
      var fixedRecipient = this.isFixedRecipientForm();
      preview.innerHTML = "\n      <div class=\"saito-user address-user\" data-id=\"".concat(this.escapeHTML(publicKey), "\" data-disable=\"true\">\n        <div class=\"saito-identicon-box\">\n          <img class=\"saito-identicon\" src=\"").concat(this.escapeHTML(identicon), "\" data-id=\"").concat(this.escapeHTML(publicKey), "\" data-disable=\"true\">\n        </div>\n        <div class=\"saito-address\" title=\"").concat(this.escapeHTML(primary), "\">").concat(this.escapeHTML(primary), "</div>\n        <div class=\"saito-userline\" title=\"").concat(this.escapeHTML(secondary), "\">").concat(this.escapeHTML(secondary), "</div>\n        <button type=\"button\" class=\"saito-icon-button address-edit ").concat(fixedRecipient ? 'hide-element' : '', "\" id=\"withdraw-address-edit\" title=\"Edit recipient address\" aria-label=\"Edit recipient address\">\n          <i class=\"fa-solid fa-pen\" aria-hidden=\"true\"></i>\n        </button>\n      </div>\n    ");
      this.attachAddressPreviewEvents();
    }
  }, {
    key: "formatChainAddressForDisplay",
    value: function formatChainAddressForDisplay() {
      var address = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var value = String(address || '');
      return value.includes('|') ? value.split('|')[0] : value;
    }
  }, {
    key: "renderExternalRecipientPreview",
    value: function renderExternalRecipientPreview() {
      var address = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var publicKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var preview = document.getElementById('withdraw-address-preview');
      if (!preview || !address) {
        return;
      }
      var displayAddress = this.formatChainAddressForDisplay(address);
      var hasPublicKey = publicKey && this.app.crypto.isPublicKey(publicKey);
      var identifier = hasPublicKey ? this.returnRegisteredIdentifier(publicKey) : '';
      var primary = hasPublicKey ? identifier || publicKey : 'External Address';
      var secondary = hasPublicKey ? publicKey : 'No matching Saito user';
      var identicon = hasPublicKey ? this.app.keychain.returnIdenticon(publicKey) : '';
      preview.innerHTML = "\n      <div class=\"address-external\">\n        <div class=\"address-external-address\" title=\"".concat(this.escapeHTML(displayAddress), "\">").concat(this.escapeHTML(displayAddress), "</div>\n        <div class=\"address-external-user ").concat(hasPublicKey ? 'saito-user address-external-user--matched' : 'address-external-user--unknown', "\" ").concat(hasPublicKey ? "data-id=\"".concat(this.escapeHTML(publicKey), "\" data-disable=\"true\"") : '', ">\n          ").concat(hasPublicKey ? "<div class=\"saito-identicon-box\">\n                  <img class=\"saito-identicon\" src=\"".concat(this.escapeHTML(identicon), "\" data-id=\"").concat(this.escapeHTML(publicKey), "\" data-disable=\"true\">\n                </div>") : "<div class=\"address-external-unknown-icon\">\n                  <i class=\"fa-solid fa-circle-question\" aria-hidden=\"true\"></i>\n                </div>", "\n          <div class=\"saito-address\" title=\"").concat(this.escapeHTML(primary), "\">\n            ").concat(this.escapeHTML(primary), "\n            ").concat(hasPublicKey ? '<span class="address-match-label">Matched</span>' : '', "\n          </div>\n          <div class=\"saito-userline\" title=\"").concat(this.escapeHTML(secondary), "\">").concat(this.escapeHTML(secondary), "</div>\n        </div>\n        <button type=\"button\" class=\"saito-icon-button address-edit\" id=\"withdraw-address-edit\" title=\"Edit recipient address\" aria-label=\"Edit recipient address\">\n          <i class=\"fa-solid fa-pen\" aria-hidden=\"true\"></i>\n        </button>\n      </div>\n    ");
      this.attachAddressPreviewEvents();
    }
  }, {
    key: "renderInvalidRecipientPreview",
    value: function renderInvalidRecipientPreview() {
      var preview = document.getElementById('withdraw-address-preview');
      if (!preview) {
        return;
      }
      preview.innerHTML = "\n      <div class=\"address-invalid\" role=\"alert\">\n        <div class=\"address-invalid-message\">".concat(this.escapeHTML("Error: Invalid ".concat(this.ticker, " address")), "</div>\n        <button type=\"button\" class=\"saito-icon-button address-edit\" id=\"withdraw-address-edit\" title=\"Edit recipient address\" aria-label=\"Edit recipient address\">\n          <i class=\"fa-solid fa-pen\" aria-hidden=\"true\"></i>\n        </button>\n      </div>\n    ");
      this.attachAddressPreviewEvents({
        preserveValue: true
      });
    }
  }, {
    key: "attachAddressPreviewEvents",
    value: function attachAddressPreviewEvents() {
      var _this3 = this;
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref2$preserveValue = _ref2.preserveValue,
        preserveValue = _ref2$preserveValue === void 0 ? false : _ref2$preserveValue;
      var editBtn = document.getElementById('withdraw-address-edit');
      if (!editBtn) {
        return;
      }
      var edit = function edit(e) {
        e.preventDefault();
        _this3.showAddressInputForEdit({
          preserveValue: preserveValue
        });
      };
      editBtn.onclick = edit;
      editBtn.onkeydown = function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          edit(e);
        }
      };
    }
  }, {
    key: "showAddressPreview",
    value: function showAddressPreview() {
      var cont = document.getElementById('withdraw-address-cont');
      var preview = document.getElementById('withdraw-address-preview');
      if (!cont || !preview) {
        return;
      }
      clearTimeout(this.addressPreviewTransitionTimer);
      if (cont.classList.contains('hide-element')) {
        preview.classList.remove('hide-element');
        preview.classList.remove('address-preview--enter');
        preview.classList.add('address-preview--enter-active');
        return;
      }
      preview.classList.add('hide-element');
      preview.classList.remove('address-preview--enter-active');
      cont.classList.add('address-transition-out');
      this.addressPreviewTransitionTimer = setTimeout(function () {
        cont.classList.add('hide-element');
        cont.classList.remove('address-transition-out');
        preview.classList.remove('hide-element');
        preview.classList.add('address-preview--enter');
        requestAnimationFrame(function () {
          preview.classList.add('address-preview--enter-active');
          preview.classList.remove('address-preview--enter');
        });
      }, 333);
    }
  }, {
    key: "hideAddressPreview",
    value: function hideAddressPreview() {
      clearTimeout(this.addressPreviewTransitionTimer);
      var preview = document.getElementById('withdraw-address-preview');
      var cont = document.getElementById('withdraw-address-cont');
      preview === null || preview === void 0 || preview.classList.add('hide-element');
      preview === null || preview === void 0 || preview.classList.remove('address-preview--enter', 'address-preview--enter-active');
      cont === null || cont === void 0 || cont.classList.remove('hide-element', 'address-transition-out');
    }
  }, {
    key: "showAddressInputForEdit",
    value: function showAddressInputForEdit() {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref3$preserveValue = _ref3.preserveValue,
        preserveValue = _ref3$preserveValue === void 0 ? false : _ref3$preserveValue;
      this.hideAddressPreview();
      var input = document.getElementById('withdraw-input-address');
      if (input && !input.disabled) {
        this.address = '';
        this.recipientAddressValid = false;
        if (!this.isFixedRecipientForm()) {
          this.publicKey = '';
        }
        if (!preserveValue) {
          input.value = '';
        }
        this.clearAddressError();
        void this.fetchWithdrawFee();
        this.handleErrors();
        input.focus();
      }
    }
  }, {
    key: "updateAddressUiFromInput",
    value: function () {
      var _updateAddressUiFromInput = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _ref4,
          _ref4$showError,
          showError,
          _ref4$fetchFee,
          fetchFee,
          input,
          lookupId,
          address,
          _registry$isRegistryI,
          registry,
          cached,
          publicKey,
          valid,
          _document$getElementB2,
          _publicKey,
          resolvedPublicKey,
          _args3 = arguments,
          _t,
          _t2;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _ref4 = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {}, _ref4$showError = _ref4.showError, showError = _ref4$showError === void 0 ? false : _ref4$showError, _ref4$fetchFee = _ref4.fetchFee, fetchFee = _ref4$fetchFee === void 0 ? true : _ref4$fetchFee;
              input = document.getElementById('withdraw-input-address');
              if (!(!input || !this.pc)) {
                _context3.n = 1;
                break;
              }
              return _context3.a(2, false);
            case 1:
              this.usernameLookupId = (this.usernameLookupId || 0) + 1;
              lookupId = this.usernameLookupId;
              this.setUsernameSearchSpinner(false);
              address = input.value.trim();
              if (address) {
                _context3.n = 2;
                break;
              }
              this.address = '';
              this.recipientAddressValid = false;
              if (!this.isFixedRecipientForm()) {
                this.publicKey = '';
              }
              this.hideAddressPreview();
              this.handleErrors();
              return _context3.a(2, false);
            case 2:
              if (!(this.isNativeSaitoSelection() && !this.pc.validateAddress(address))) {
                _context3.n = 9;
                break;
              }
              registry = this.app.modules.returnModule('Registry');
              if (!(registry !== null && registry !== void 0 && (_registry$isRegistryI = registry.isRegistryIdentifier) !== null && _registry$isRegistryI !== void 0 && _registry$isRegistryI.call(registry, address))) {
                _context3.n = 9;
                break;
              }
              cached = this.app.keychain.returnKey({
                identifier: address
              });
              publicKey = cached !== null && cached !== void 0 && cached.publicKey && this.app.crypto.isPublicKey(cached.publicKey) ? cached.publicKey : '';
              if (publicKey) {
                _context3.n = 8;
                break;
              }
              this.setUsernameSearchSpinner(true);
              _context3.p = 3;
              _context3.n = 4;
              return registry.resolveIdentifier(address);
            case 4:
              publicKey = _context3.v;
              _context3.n = 6;
              break;
            case 5:
              _context3.p = 5;
              _t = _context3.v;
              console.warn('Withdraw: unable to resolve username', _t);
              publicKey = '';
            case 6:
              if (!(lookupId !== this.usernameLookupId || input.value.trim() !== address)) {
                _context3.n = 7;
                break;
              }
              return _context3.a(2, false);
            case 7:
              this.setUsernameSearchSpinner(false);
            case 8:
              if (publicKey && this.app.crypto.isPublicKey(publicKey)) {
                input.value = publicKey;
                address = publicKey;
              }
            case 9:
              valid = this.pc.validateAddress(address);
              if (valid) {
                _context3.n = 10;
                break;
              }
              this.address = '';
              this.recipientAddressValid = false;
              if (!this.isFixedRecipientForm()) {
                this.publicKey = '';
              }
              if (showError) {
                this.errors['address'] = true;
                this.renderInvalidRecipientPreview();
                this.showAddressPreview();
              } else {
                this.hideAddressPreview();
              }
              this.handleErrors();
              return _context3.a(2, false);
            case 10:
              this.address = address;
              this.recipientAddressValid = true;
              this.clearAddressError();
              if (!this.isNativeSaitoSelection()) {
                _context3.n = 11;
                break;
              }
              this.publicKey = address;
              this.renderSaitoRecipientPreview(address);
              this.showAddressPreview();
              (_document$getElementB2 = document.getElementById('withdraw-input-amount')) === null || _document$getElementB2 === void 0 || _document$getElementB2.focus();
              _context3.n = 16;
              break;
            case 11:
              _publicKey = this.app.crypto.isPublicKey(this.publicKey) ? this.publicKey : '';
              if (!(typeof this.pc.getSaitoPublicKey === 'function')) {
                _context3.n = 15;
                break;
              }
              _context3.p = 12;
              _context3.n = 13;
              return this.pc.getSaitoPublicKey(address);
            case 13:
              resolvedPublicKey = _context3.v;
              if (resolvedPublicKey && this.app.crypto.isPublicKey(resolvedPublicKey)) {
                this.publicKey = resolvedPublicKey;
                _publicKey = resolvedPublicKey;
              } else if (!this.isFixedRecipientForm()) {
                this.publicKey = '';
                _publicKey = '';
              }
              _context3.n = 15;
              break;
            case 14:
              _context3.p = 14;
              _t2 = _context3.v;
              console.warn('Withdraw: unable to resolve Saito public key for address', _t2);
              if (!this.isFixedRecipientForm()) {
                this.publicKey = '';
                _publicKey = '';
              }
            case 15:
              if (!this.isFixedRecipientForm()) {
                this.publicKey = _publicKey;
              }
              this.renderExternalRecipientPreview(address, _publicKey);
              this.showAddressPreview();
            case 16:
              if (!fetchFee) {
                _context3.n = 17;
                break;
              }
              _context3.n = 17;
              return this.fetchWithdrawFee();
            case 17:
              this.updateAmountActionState();
              this.handleErrors();
              return _context3.a(2, true);
          }
        }, _callee3, this, [[12, 14], [3, 5]]);
      }));
      function updateAddressUiFromInput() {
        return _updateAddressUiFromInput.apply(this, arguments);
      }
      return updateAddressUiFromInput;
    }()
  }, {
    key: "formatFeeTicker",
    value: function formatFeeTicker() {
      if (this.feeTicker) {
        return this.feeTicker;
      }
      if (!this.pc) {
        return this.ticker || '';
      }
      return this.pc.chain_id === 'NATIVE' ? 'SAITO' : this.ticker;
    }
  }, {
    key: "getNativeDefaultFee",
    value: function getNativeDefaultFee() {
      try {
        var _ref5, _this$app$wallet$defa, _this$app$options;
        var configuredFee = (_ref5 = (_this$app$wallet$defa = this.app.wallet.default_fee) !== null && _this$app$wallet$defa !== void 0 ? _this$app$wallet$defa : (_this$app$options = this.app.options) === null || _this$app$options === void 0 || (_this$app$options = _this$app$options.wallet) === null || _this$app$options === void 0 ? void 0 : _this$app$options.default_fee) !== null && _ref5 !== void 0 ? _ref5 : BigInt(0);
        var fee = Number(this.app.wallet.convertNolanToSaito(BigInt(configuredFee)));
        return Number.isFinite(fee) && fee >= 0 ? fee : 0;
      } catch (err) {
        return 0;
      }
    }
  }, {
    key: "formatFeeDisplay",
    value: function formatFeeDisplay(amt) {
      var n = Number(amt);
      if (!Number.isFinite(n)) {
        return '--';
      }
      if (n === 0) {
        return "0 ".concat(this.formatFeeTicker());
      }
      return "".concat(this.app.browser.formatDecimals(String(n)), " ").concat(this.formatFeeTicker());
    }
  }, {
    key: "setFeeDisplayElement",
    value: function setFeeDisplayElement(el, text) {
      var title = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      if (!el) {
        return;
      }
      el.textContent = text;
      if (title) {
        el.setAttribute('title', title);
      } else {
        el.removeAttribute('title');
      }
    }
  }, {
    key: "setWithdrawStep",
    value: function setWithdrawStep(step) {
      var _document$getElementB3;
      var form = document.getElementById('withdrawal-form');
      var one = document.getElementById('withdraw-step-one');
      var two = document.getElementById('withdraw-step-two');
      if (form) {
        form.dataset.withdrawStep = step;
      }
      if (one) {
        one.classList.toggle('hide-element', step !== 'compose');
      }
      if (two) {
        two.classList.toggle('hide-element', step !== 'review');
      }
      (_document$getElementB3 = document.getElementById('withdraw-footer-compose')) === null || _document$getElementB3 === void 0 || _document$getElementB3.classList.toggle('hide-element', step !== 'compose');
      if (step === 'compose') {
        this.setWithdrawState('review');
      }
    }

    /**
     * @param {'review'|'pending'|'success'|'failed'} state
     */
  }, {
    key: "setWithdrawState",
    value: function setWithdrawState(state) {
      var form = document.getElementById('withdrawal-form');
      if (form) {
        form.dataset.withdrawState = state;
      }
      var onReview = (form === null || form === void 0 ? void 0 : form.dataset.withdrawStep) === 'review';
      var footers = {
        review: document.getElementById('withdraw-footer-review'),
        failed: document.getElementById('withdraw-footer-failed')
      };
      for (var _i = 0, _Object$keys = Object.keys(footers); _i < _Object$keys.length; _i++) {
        var _footers$key;
        var key = _Object$keys[_i];
        var showFooter = onReview && key === state;
        (_footers$key = footers[key]) === null || _footers$key === void 0 || _footers$key.classList.toggle('hide-element', !showFooter);
      }
      var spinner = document.getElementById('withdraw-confirm-spinner');
      var iconOk = document.getElementById('withdraw-confirm-icon-success');
      var iconFail = document.getElementById('withdraw-confirm-icon-failure');
      if (spinner) {
        spinner.classList.toggle('show', state === 'pending');
      }
      if (iconOk) {
        iconOk.classList.toggle('hide-element', state !== 'success');
      }
      if (iconFail) {
        iconFail.classList.toggle('hide-element', state !== 'failed');
      }
      this.updateSendResultPresentation(state);
    }

    /**
     * Header + send-result copy for review-step substates (review / pending / success / failed).
     * The DOM step stays #withdraw-step-two; data-withdraw-state drives the sub-view.
     */
  }, {
    key: "updateSendResultPresentation",
    value: function updateSendResultPresentation(state) {
      var overlayTitle = document.getElementById('withdraw-overlay-title');
      var resultPanel = document.getElementById('withdraw-send-result');
      var resultTitle = document.getElementById('withdraw-send-result-title');
      var resultMessage = document.getElementById('withdraw-send-result-message');
      var isResult = state === 'pending' || state === 'success' || state === 'failed';
      resultPanel === null || resultPanel === void 0 || resultPanel.classList.toggle('hide-element', !isResult);
      if (state === 'success') {
        if (overlayTitle) {
          overlayTitle.textContent = 'Payment sent';
        }
        if (resultTitle) {
          resultTitle.textContent = 'Transaction broadcast';
        }
        if (resultMessage) {
          resultMessage.textContent = 'Check recent transactions for confirmation.';
        }
      } else if (state === 'failed') {
        if (overlayTitle) {
          overlayTitle.textContent = 'Payment failed';
        }
        if (resultTitle) {
          resultTitle.textContent = 'Transfer unsuccessful';
        }
      } else if (state === 'pending') {
        if (overlayTitle) {
          overlayTitle.textContent = 'Sending…';
        }
        if (resultTitle) {
          resultTitle.textContent = 'Broadcasting Transaction';
        }
        if (resultMessage) {
          resultMessage.textContent = 'Waiting for the network to accept this transfer.';
        }
      } else {
        this.updateHeaderTitle();
        if (resultMessage) {
          resultMessage.textContent = '';
        }
      }
    }
  }, {
    key: "showReviewStep",
    value: function showReviewStep() {
      this.setWithdrawStep('review');
      this.setWithdrawState('review');
      this.populateReviewDetails();
      var confirmBtn = document.getElementById('withdraw-confirm');
      confirmBtn === null || confirmBtn === void 0 || confirmBtn.focus();
    }
  }, {
    key: "populateReviewDetails",
    value: function populateReviewDetails() {
      this.hideSendResultMessage();
      this.hideTxRow();
      var amountEl = document.getElementById('withdraw-confirm-amount');
      if (amountEl) {
        amountEl.textContent = "".concat(this.getAmountInputDisplayValue(), " ").concat(this.ticker);
      }
      var addressEl = document.getElementById('withdraw-confirm-address');
      if (addressEl) {
        var showChainAddress = this.address && this.address !== this.publicKey;
        addressEl.classList.toggle('hide-element', !showChainAddress);
        if (showChainAddress) {
          var a = this.address;
          if (a.includes('|')) {
            a = a.split('|')[0];
          }
          addressEl.textContent = a;
        } else {
          addressEl.textContent = '';
        }
      }
      var feeEl = document.getElementById('withdraw-confirm-fee');
      if (feeEl) {
        feeEl.textContent = this.formatFeeDisplay(this.fee);
      }
      var counterpartyWrap = document.getElementById('withdraw-confirm-counterparty');
      if (counterpartyWrap) {
        if (this.publicKey && this.app.crypto.isPublicKey(this.publicKey)) {
          counterpartyWrap.classList.remove('hide-element');
          this.counterparty.publicKey = this.publicKey;
          this.counterparty.render();
          this.counterparty.updateUserline(this.publicKey, this.publicKey);
        } else {
          counterpartyWrap.classList.add('hide-element');
          counterpartyWrap.innerHTML = '';
        }
      }
    }
  }, {
    key: "resolveRecipientPublicKey",
    value: function () {
      var _resolveRecipientPublicKey = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var publicKey, _t3;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              if (!this.isNativeSaitoSelection()) {
                _context4.n = 1;
                break;
              }
              this.publicKey = this.address;
              _context4.n = 7;
              break;
            case 1:
              if (!(typeof this.pc.getSaitoPublicKey === 'function')) {
                _context4.n = 6;
                break;
              }
              _context4.p = 2;
              _context4.n = 3;
              return this.pc.getSaitoPublicKey(this.address);
            case 3:
              publicKey = _context4.v;
              if (publicKey) {
                this.publicKey = publicKey;
              }
              _context4.n = 5;
              break;
            case 4:
              _context4.p = 4;
              _t3 = _context4.v;
              console.warn('Withdraw: unable to resolve Saito public key for address', _t3);
            case 5:
              _context4.n = 7;
              break;
            case 6:
              if (!this.publicKey) {
                this.publicKey = '';
              }
            case 7:
              return _context4.a(2);
          }
        }, _callee4, this, [[2, 4]]);
      }));
      function resolveRecipientPublicKey() {
        return _resolveRecipientPublicKey.apply(this, arguments);
      }
      return resolveRecipientPublicKey;
    }()
  }, {
    key: "getSenderExplorerKey",
    value: function getSenderExplorerKey() {
      var _this$app$wallet, _this$app$wallet2, _this$app$wallet2$ret;
      return ((_this$app$wallet = this.app.wallet) === null || _this$app$wallet === void 0 ? void 0 : _this$app$wallet.publicKey) || ((_this$app$wallet2 = this.app.wallet) === null || _this$app$wallet2 === void 0 || (_this$app$wallet2$ret = _this$app$wallet2.returnPublicKey) === null || _this$app$wallet2$ret === void 0 ? void 0 : _this$app$wallet2$ret.call(_this$app$wallet2)) || '';
    }
  }, {
    key: "updateSuccessAction",
    value: function updateSuccessAction() {
      var action = document.getElementById('withdraw-confirm-tx-explorer');
      if (!action) {
        return;
      }
      if (this.isNativeSaitoSelection()) {
        var key = this.getSenderExplorerKey();
        action.href = key ? "/explorer/address/".concat(encodeURIComponent(key)) : '/explorer';
      } else {
        action.href = '#';
      }
    }
  }, {
    key: "sendWithdrawPayment",
    value: function () {
      var _sendWithdrawPayment = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var _this4 = this;
        var amount, ticker, sender, ts, _t4;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              _context6.p = 0;
              amount = this.getAmountInputValue();
              ticker = this.ticker;
              sender = this.pc.formatAddress();
              this.populateReviewDetails();
              this.setWithdrawStep('review');
              this.setWithdrawState('pending');
              ts = new Date().getTime();
              _context6.n = 1;
              return this.app.wallet.sendPayment(ticker, [sender], [this.address], [amount], btoa(sender + this.address + amount + ts), /*#__PURE__*/function () {
                var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(res) {
                  var _res$err, errMsg;
                  return _regenerator().w(function (_context5) {
                    while (1) switch (_context5.n) {
                      case 0:
                        if (res !== null && res !== void 0 && res.hash && !(res !== null && res !== void 0 && res.err)) {
                          _this4.withdrawBroadcastSuccessUi(res.hash);
                        } else {
                          errMsg = typeof (res === null || res === void 0 ? void 0 : res.err) === 'string' ? res.err : res !== null && res !== void 0 && (_res$err = res.err) !== null && _res$err !== void 0 && _res$err.message ? String(res.err.message) : '';
                          _this4.showError(errMsg);
                        }
                      case 1:
                        return _context5.a(2);
                    }
                  }, _callee5);
                }));
                return function (_x2) {
                  return _ref6.apply(this, arguments);
                };
              }(), this === null || this === void 0 ? void 0 : this.publicKey);
            case 1:
              _context6.n = 3;
              break;
            case 2:
              _context6.p = 2;
              _t4 = _context6.v;
              console.error('Send Error: ' + _t4);
              this.showError((_t4 === null || _t4 === void 0 ? void 0 : _t4.message) || String(_t4));
            case 3:
              return _context6.a(2);
          }
        }, _callee6, this, [[0, 2]]);
      }));
      function sendWithdrawPayment() {
        return _sendWithdrawPayment.apply(this, arguments);
      }
      return sendWithdrawPayment;
    }()
  }, {
    key: "showComposeStep",
    value: function showComposeStep() {
      var _document$getElementB4;
      this.setWithdrawStep('compose');
      this.setWithdrawState('review');
      this.resetConfirmPresentation();
      (_document$getElementB4 = document.getElementById('withdraw-input-address')) === null || _document$getElementB4 === void 0 || _document$getElementB4.focus();
    }
  }, {
    key: "resetConfirmPresentation",
    value: function resetConfirmPresentation() {
      var _document$getElementB5, _document$getElementB6, _document$getElementB7;
      this.hideSendResultMessage();
      this.hideTxRow();
      this.lastTxHash = '';
      var spinner = document.getElementById('withdraw-confirm-spinner');
      spinner === null || spinner === void 0 || spinner.classList.remove('show');
      (_document$getElementB5 = document.getElementById('withdraw-confirm-icon-success')) === null || _document$getElementB5 === void 0 || _document$getElementB5.classList.add('hide-element');
      (_document$getElementB6 = document.getElementById('withdraw-confirm-icon-failure')) === null || _document$getElementB6 === void 0 || _document$getElementB6.classList.add('hide-element');
      (_document$getElementB7 = document.getElementById('withdraw-send-result')) === null || _document$getElementB7 === void 0 || _document$getElementB7.classList.add('hide-element');
    }
  }, {
    key: "hideSendResultMessage",
    value: function hideSendResultMessage() {
      var el = document.getElementById('withdraw-send-result-message');
      if (el) {
        el.textContent = '';
      }
    }
  }, {
    key: "hideTxRow",
    value: function hideTxRow() {
      var _document$getElementB8;
      (_document$getElementB8 = document.getElementById('withdraw-confirm-tx-row')) === null || _document$getElementB8 === void 0 || _document$getElementB8.classList.add('hide-element');
      var hashEl = document.getElementById('withdraw-confirm-tx-hash');
      if (hashEl) {
        hashEl.textContent = '';
      }
    }
  }, {
    key: "showTxRow",
    value: function showTxRow(hash) {
      if (!hash) {
        return;
      }
      this.lastTxHash = hash;
      var row = document.getElementById('withdraw-confirm-tx-row');
      var hashEl = document.getElementById('withdraw-confirm-tx-hash');
      if (row && hashEl) {
        hashEl.textContent = hash;
        hashEl.setAttribute('title', hash);
        row.classList.remove('hide-element');
      }
    }
  }, {
    key: "refreshAvailableBalanceDisplay",
    value: function () {
      var _refreshAvailableBalanceDisplay = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var _document$getElementB9;
        var el, raw, n;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              el = document.getElementById('withdraw-balance-display') || document.querySelector('.withdraw-info-value.balance');
              if (!(!this.pc || !el)) {
                _context7.n = 1;
                break;
              }
              return _context7.a(2);
            case 1:
              _context7.n = 2;
              return this.pc.getAvailableBalance();
            case 2:
              raw = _context7.v;
              if (this.isNftWithdrawSelection()) {
                this._nft_balance_raw = String(raw).trim();
              } else {
                this._nft_balance_raw = null;
              }
              n = Number(raw);
              this.available_balance = Number.isFinite(n) ? n : 0;
              el.textContent = "".concat(this.app.browser.formatDecimals(String(this.available_balance)), " ").concat(this.ticker);
              if ((_document$getElementB9 = document.getElementById('withdraw-input-amount')) !== null && _document$getElementB9 !== void 0 && (_document$getElementB9 = _document$getElementB9.value) !== null && _document$getElementB9 !== void 0 && _document$getElementB9.trim()) {
                this.validateAmountInput();
              }
            case 3:
              return _context7.a(2);
          }
        }, _callee7, this);
      }));
      function refreshAvailableBalanceDisplay() {
        return _refreshAvailableBalanceDisplay.apply(this, arguments);
      }
      return refreshAvailableBalanceDisplay;
    }()
  }, {
    key: "loadCryptos",
    value: function () {
      var _loadCryptos = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var sel, menu, available_cryptos, _iterator, _step, crypto_mod, show_me, html, icons, img_html, li, sub, triggerTick, _t5, _t6, _t7;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.p = _context8.n) {
            case 0:
              sel = document.getElementById('withdraw-select-crypto');
              menu = document.getElementById('withdraw-token-menu');
              if (sel) {
                sel.replaceChildren();
              }
              if (menu) {
                menu.replaceChildren();
              }
              available_cryptos = this.returnAvailableCryptos();
              _iterator = _createForOfIteratorHelper(available_cryptos);
              _context8.p = 1;
              _iterator.s();
            case 2:
              if ((_step = _iterator.n()).done) {
                _context8.n = 6;
                break;
              }
              crypto_mod = _step.value;
              _t5 = !(this !== null && this !== void 0 && this.publicKey);
              if (_t5) {
                _context8.n = 4;
                break;
              }
              _context8.n = 3;
              return crypto_mod.returnAddressFromPublicKey(this.publicKey);
            case 3:
              _t6 = _context8.v;
              _t5 = _t6 !== null;
            case 4:
              if (!_t5) {
                _context8.n = 5;
                break;
              }
              show_me = crypto_mod.name == this.pc.name;
              html = "<option ".concat(show_me ? 'selected' : "", " id=\"crypto-option-").concat(crypto_mod.name, "\" value=\"").concat(crypto_mod.ticker, "\">").concat(crypto_mod.ticker, "</option>");
              this.app.browser.addElementToId(html, 'withdraw-select-crypto');
              icons = crypto_mod.returnLogos();
              img_html = "<img class=\"crypto-logo hide-element\" data-ticker=\"".concat(crypto_mod.ticker, "\" src=\"").concat(icons.img, "\">");
              if (icons.sub_logo) {
                img_html += "<img class=\"chain-logo hide-element\" data-ticker=\"".concat(crypto_mod.ticker, "\" src=\"").concat(icons.sub_logo, "\">");
              }
              this.app.browser.addElementToId(img_html, 'withdraw-logo-cont');
              if (menu) {
                li = document.createElement('li');
                li.className = 'withdraw-token-option saito-form-dropdown-option';
                li.setAttribute('role', 'option');
                li.setAttribute('aria-selected', show_me ? 'true' : 'false');
                li.dataset.ticker = crypto_mod.ticker;
                sub = '';
                if (icons.sub_logo) {
                  sub = "<img class=\"withdraw-token-option-chain\" src=\"".concat(icons.sub_logo, "\" alt=\"\" />");
                }
                li.innerHTML = "<img class=\"withdraw-token-option-logo\" src=\"".concat(icons.img, "\" alt=\"\" />").concat(sub, "<span class=\"withdraw-token-option-ticker\">").concat(crypto_mod.ticker, "</span>");
                menu.appendChild(li);
              }
            case 5:
              _context8.n = 2;
              break;
            case 6:
              _context8.n = 8;
              break;
            case 7:
              _context8.p = 7;
              _t7 = _context8.v;
              _iterator.e(_t7);
            case 8:
              _context8.p = 8;
              _iterator.f();
              return _context8.f(8);
            case 9:
              triggerTick = document.getElementById('withdraw-token-trigger-ticker');
              if (triggerTick) {
                triggerTick.textContent = this.pc.ticker;
              }
            case 10:
              return _context8.a(2);
          }
        }, _callee8, this, [[1, 7, 8, 9]]);
      }));
      function loadCryptos() {
        return _loadCryptos.apply(this, arguments);
      }
      return loadCryptos;
    }()
  }, {
    key: "returnAvailableCryptos",
    value: function returnAvailableCryptos() {
      var hasWithdrawQuery = Boolean(this.app.browser.returnURLParameter('withdraw'));
      var available_cryptos = this.app.wallet.returnActivatedCryptos().filter(function (crypto_module) {
        return hasWithdrawQuery || !QUERY_GATED_TICKERS.has(crypto_module.ticker);
      });
      if (!hasWithdrawQuery) {
        return available_cryptos;
      }
      var installed_tickers = new Set(available_cryptos.map(function (crypto_mod) {
        return crypto_mod.ticker;
      }));
      for (var _i2 = 0, _WRAPPED_SAITO_TICKER = WRAPPED_SAITO_TICKERS; _i2 < _WRAPPED_SAITO_TICKER.length; _i2++) {
        var ticker = _WRAPPED_SAITO_TICKER[_i2];
        var crypto_mod = this.app.wallet.returnCryptoModuleByTicker(ticker);
        if (crypto_mod && !installed_tickers.has(crypto_mod.ticker)) {
          available_cryptos.push(crypto_mod);
          installed_tickers.add(crypto_mod.ticker);
        }
      }
      return available_cryptos;
    }
  }, {
    key: "positionTokenMenu",
    value: function positionTokenMenu() {
      var menu = document.getElementById('withdraw-token-menu');
      var trigger = document.getElementById('withdraw-token-trigger');
      if (!menu || !trigger) {
        return;
      }
      var viewportGap = 8;
      var triggerGap = 2;
      var triggerRect = trigger.getBoundingClientRect();
      var rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize) || 10;
      var preferredMaxHeight = 20 * rootFontSize;
      var desiredHeight = Math.min(preferredMaxHeight, menu.scrollHeight);
      var spaceBelow = window.innerHeight - triggerRect.bottom - viewportGap - triggerGap;
      var spaceAbove = triggerRect.top - viewportGap - triggerGap;
      var openAbove = spaceAbove > spaceBelow && spaceBelow < desiredHeight;
      var availableHeight = Math.max(0, openAbove ? spaceAbove : spaceBelow);
      var menuHeight = Math.min(desiredHeight, availableHeight);
      var menuWidth = Math.min(triggerRect.width, window.innerWidth - 2 * viewportGap);
      var menuLeft = Math.min(Math.max(viewportGap, triggerRect.left), window.innerWidth - viewportGap - menuWidth);
      menu.style.left = "".concat(menuLeft, "px");
      menu.style.top = "".concat(openAbove ? Math.max(viewportGap, triggerRect.top - triggerGap - menuHeight) : triggerRect.bottom + triggerGap, "px");
      menu.style.width = "".concat(menuWidth, "px");
      menu.style.maxHeight = "".concat(menuHeight, "px");
    }
  }, {
    key: "openTokenMenu",
    value: function openTokenMenu() {
      var _this5 = this,
        _this$_tokenMenuScrol;
      var menu = document.getElementById('withdraw-token-menu');
      var trigger = document.getElementById('withdraw-token-trigger');
      if (!menu || !trigger) {
        return;
      }
      menu.classList.remove('hide-element');
      if (typeof menu.showPopover === 'function' && !menu.matches(':popover-open')) {
        menu.showPopover();
      }
      this.positionTokenMenu();
      trigger.setAttribute('aria-expanded', 'true');
      this._closeTokenMenuOnViewportChange || (this._closeTokenMenuOnViewportChange = function () {
        return _this5.closeTokenMenu();
      });
      this._tokenMenuScrollContainer = trigger.closest('.compose');
      window.addEventListener('resize', this._closeTokenMenuOnViewportChange);
      window.addEventListener('scroll', this._closeTokenMenuOnViewportChange);
      (_this$_tokenMenuScrol = this._tokenMenuScrollContainer) === null || _this$_tokenMenuScrol === void 0 || _this$_tokenMenuScrol.addEventListener('scroll', this._closeTokenMenuOnViewportChange);
    }
  }, {
    key: "closeTokenMenu",
    value: function closeTokenMenu() {
      var menu = document.getElementById('withdraw-token-menu');
      var trigger = document.getElementById('withdraw-token-trigger');
      if (menu) {
        if (typeof menu.hidePopover === 'function' && menu.matches(':popover-open')) {
          menu.hidePopover();
        }
        menu.classList.add('hide-element');
      }
      trigger === null || trigger === void 0 || trigger.setAttribute('aria-expanded', 'false');
      if (this._closeTokenMenuOnViewportChange) {
        var _this$_tokenMenuScrol2;
        window.removeEventListener('resize', this._closeTokenMenuOnViewportChange);
        window.removeEventListener('scroll', this._closeTokenMenuOnViewportChange);
        (_this$_tokenMenuScrol2 = this._tokenMenuScrollContainer) === null || _this$_tokenMenuScrol2 === void 0 || _this$_tokenMenuScrol2.removeEventListener('scroll', this._closeTokenMenuOnViewportChange);
      }
      this._tokenMenuScrollContainer = null;
    }
  }, {
    key: "focusTokenOption",
    value: function focusTokenOption(index) {
      var _options$i;
      var options = Array.from(document.querySelectorAll('.withdraw-token-option'));
      if (!options.length) {
        return;
      }
      var i = Math.max(0, Math.min(index, options.length - 1));
      options.forEach(function (el, idx) {
        return el.classList.toggle('withdraw-token-option--focused', idx === i);
      });
      (_options$i = options[i]) === null || _options$i === void 0 || _options$i.scrollIntoView({
        block: 'nearest'
      });
      this._tokenMenuFocusIndex = i;
    }
  }, {
    key: "selectCryptoTicker",
    value: function () {
      var _selectCryptoTicker = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(ticker) {
        var balEl, sel, triggerTick;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              balEl = document.getElementById('withdraw-balance-display') || document.querySelector('.withdraw-info-value.balance');
              if (balEl) {
                balEl.textContent = 'Updating…';
              }
              document.querySelectorAll("#withdraw-logo-cont img").forEach(function (el) {
                return el.classList.add('hide-element');
              });
              document.querySelectorAll("#withdraw-logo-cont img[data-ticker=\"".concat(ticker, "\"]")).forEach(function (el) {
                return el.classList.remove('hide-element');
              });
              _context9.n = 1;
              return this.app.wallet.setPreferredCrypto(ticker);
            case 1:
              this.fee = null;
              sel = document.getElementById('withdraw-select-crypto');
              if (sel) {
                sel.value = ticker;
              }
              triggerTick = document.getElementById('withdraw-token-trigger-ticker');
              if (triggerTick) {
                triggerTick.textContent = ticker;
              }
              document.querySelectorAll('.withdraw-token-option').forEach(function (li) {
                li.setAttribute('aria-selected', li.dataset.ticker === ticker ? 'true' : 'false');
              });
              if (!this.publicKey) {
                _context9.n = 2;
                break;
              }
              this.closeTokenMenu();
              this.render();
              return _context9.a(2);
            case 2:
              document.querySelector('#withdraw-input-address').value = '';
              document.querySelector('#withdraw-input-amount').value = '';
              this.hideAddressPreview();
              this.resetAmountValidation();
              this.resetErrors();
              this.pc = this.app.wallet.returnPreferredCrypto();
              this.ticker = this.pc.ticker;
              this.address = '';
              this.recipientAddressValid = false;
              this.publicKey = '';
              this.amountErrorMessage = '';
              this.updateHeaderTitle();
              this.updateComposeLabels();
              _context9.n = 3;
              return this.fetchWithdrawFee();
            case 3:
              _context9.n = 4;
              return this.refreshAvailableBalanceDisplay();
            case 4:
              this.updateHeaderLogos();
              this.closeTokenMenu();
            case 5:
              return _context9.a(2);
          }
        }, _callee9, this);
      }));
      function selectCryptoTicker(_x3) {
        return _selectCryptoTicker.apply(this, arguments);
      }
      return selectCryptoTicker;
    }()
  }, {
    key: "applyAddressInputValue",
    value: function () {
      var _applyAddressInputValue = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(value) {
        var input, address;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.n) {
            case 0:
              input = document.getElementById('withdraw-input-address');
              if (!(!input || input.disabled)) {
                _context0.n = 1;
                break;
              }
              return _context0.a(2);
            case 1:
              address = typeof value === 'string' ? value.trim() : '';
              if (address) {
                _context0.n = 2;
                break;
              }
              return _context0.a(2);
            case 2:
              input.focus();
              if (!this.isFixedRecipientForm()) {
                this.publicKey = '';
              }
              input.value = address;
              _context0.n = 3;
              return this.updateAddressUiFromInput({
                showError: true
              });
            case 3:
              return _context0.a(2);
          }
        }, _callee0, this);
      }));
      function applyAddressInputValue(_x4) {
        return _applyAddressInputValue.apply(this, arguments);
      }
      return applyAddressInputValue;
    }()
  }, {
    key: "pasteAddress",
    value: function () {
      var _pasteAddress = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1() {
        var text, _t8;
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.p = _context1.n) {
            case 0:
              _context1.p = 0;
              _context1.n = 1;
              return navigator.clipboard.readText();
            case 1:
              text = _context1.v;
              _context1.n = 2;
              return this.applyAddressInputValue(text);
            case 2:
              _context1.n = 4;
              break;
            case 3:
              _context1.p = 3;
              _t8 = _context1.v;
              console.warn('withdraw paste:', _t8);
            case 4:
              return _context1.a(2);
          }
        }, _callee1, this, [[0, 3]]);
      }));
      function pasteAddress() {
        return _pasteAddress.apply(this, arguments);
      }
      return pasteAddress;
    }()
  }, {
    key: "scanAddress",
    value: function scanAddress() {
      var _this6 = this;
      this.app.connection.emit('scanner-start-scanner', function (data) {
        void _this6.applyAddressInputValue(data);
      });
    }
  }, {
    key: "copyWithFeedback",
    value: function () {
      var _copyWithFeedback = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10(button, text) {
        var icon, _t9;
        return _regenerator().w(function (_context10) {
          while (1) switch (_context10.p = _context10.n) {
            case 0:
              if (text) {
                _context10.n = 1;
                break;
              }
              return _context10.a(2);
            case 1:
              _context10.p = 1;
              _context10.n = 2;
              return navigator.clipboard.writeText(text);
            case 2:
              icon = button === null || button === void 0 ? void 0 : button.querySelector('i');
              if (icon) {
                icon.classList.remove('fa-copy');
                icon.classList.add('fa-check');
                setTimeout(function () {
                  icon.classList.add('fa-copy');
                  icon.classList.remove('fa-check');
                }, 800);
              }
              _context10.n = 4;
              break;
            case 3:
              _context10.p = 3;
              _t9 = _context10.v;
              console.warn('withdraw copy:', _t9);
            case 4:
              return _context10.a(2);
          }
        }, _callee10, null, [[1, 3]]);
      }));
      function copyWithFeedback(_x5, _x6) {
        return _copyWithFeedback.apply(this, arguments);
      }
      return copyWithFeedback;
    }()
  }, {
    key: "attachEvents",
    value: function () {
      var _attachEvents = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee16() {
        var _this7 = this;
        var this_withdraw, trigger, menu, addrInput, clearAddressUi, amtInput, pasteBtn, scanBtn, feeWrap, txCopyBtn, copyTxHash, editBtn, tryEditBtn, tryAgainBtn, explorerLink, form, confirmBtn, maxBtn;
        return _regenerator().w(function (_context16) {
          while (1) switch (_context16.n) {
            case 0:
              this_withdraw = this;
              this._tokenMenuFocusIndex = -1;
              trigger = document.getElementById('withdraw-token-trigger');
              menu = document.getElementById('withdraw-token-menu');
              if (trigger && menu) {
                trigger.onclick = function (e) {
                  e.stopPropagation();
                  var open = menu.classList.contains('hide-element');
                  if (open) {
                    _this7.openTokenMenu();
                    var currentIdx = Array.from(menu.querySelectorAll('.withdraw-token-option')).findIndex(function (li) {
                      return li.dataset.ticker === _this7.ticker;
                    });
                    _this7.focusTokenOption(currentIdx >= 0 ? currentIdx : 0);
                    setTimeout(function () {
                      document.addEventListener('click', function (ev) {
                        if (ev.target.closest('#withdraw-token-custom')) {
                          return;
                        }
                        _this7.closeTokenMenu();
                      }, {
                        once: true
                      });
                    }, 0);
                  } else {
                    _this7.closeTokenMenu();
                  }
                };
                trigger.onkeydown = function (e) {
                  var open = !menu.classList.contains('hide-element');
                  if (e.key === 'Escape') {
                    _this7.closeTokenMenu();
                    return;
                  }
                  if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
                    e.preventDefault();
                    if (!open) {
                      _this7.openTokenMenu();
                    }
                    var options = Array.from(menu.querySelectorAll('.withdraw-token-option'));
                    var idx = _this7._tokenMenuFocusIndex;
                    if (idx < 0) {
                      idx = options.findIndex(function (li) {
                        return li.dataset.ticker === _this7.ticker;
                      });
                    }
                    idx += e.key === 'ArrowDown' ? 1 : -1;
                    _this7.focusTokenOption(idx);
                  }
                  if (e.key === 'Enter' && open) {
                    var _focused$dataset;
                    e.preventDefault();
                    var focused = menu.querySelector('.withdraw-token-option--focused');
                    var ticker = focused === null || focused === void 0 || (_focused$dataset = focused.dataset) === null || _focused$dataset === void 0 ? void 0 : _focused$dataset.ticker;
                    if (ticker && ticker !== _this7.ticker) {
                      void _this7.selectCryptoTicker(ticker);
                    } else {
                      _this7.closeTokenMenu();
                    }
                  }
                };
                menu.onclick = function (e) {
                  var li = e.target.closest('.withdraw-token-option');
                  if (!li || !li.dataset.ticker) {
                    return;
                  }
                  e.stopPropagation();
                  if (li.dataset.ticker !== _this7.ticker) {
                    void _this7.selectCryptoTicker(li.dataset.ticker);
                  }
                };
              }
              addrInput = document.querySelector('#withdraw-input-address');
              if (addrInput) {
                clearAddressUi = function clearAddressUi() {
                  _this7.clearAddressError();
                  _this7.handleErrors();
                };
                addrInput.onfocus = clearAddressUi;
                addrInput.oninput = function () {
                  if (!_this7.isFixedRecipientForm()) {
                    _this7.publicKey = '';
                  }
                  clearAddressUi();
                  void _this7.updateAddressUiFromInput();
                };
                addrInput.onblur = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11() {
                  return _regenerator().w(function (_context11) {
                    while (1) switch (_context11.n) {
                      case 0:
                        _context11.n = 1;
                        return _this7.updateAddressUiFromInput({
                          showError: true
                        });
                      case 1:
                        return _context11.a(2);
                    }
                  }, _callee11);
                }));
              }
              amtInput = document.querySelector('#withdraw-input-amount');
              if (amtInput) {
                amtInput.onfocus = function () {
                  _this7.updateAmountActionState();
                };
                amtInput.oninput = function () {
                  _this7.normalizeAmountInput();
                  _this7.validateAmountInput();
                };
                amtInput.onpaste = function () {
                  setTimeout(function () {
                    _this7.normalizeAmountInput({
                      strictLocaleSeparators: false
                    });
                    _this7.validateAmountInput();
                  }, 0);
                };
                amtInput.onblur = function () {
                  _this7.normalizeAmountInput();
                  _this7.updateAmountActionState();
                  _this7.validateAmountInput();
                };
                amtInput.onchange = function () {
                  _this7.normalizeAmountInput();
                  _this7.validateAmountInput();
                };
              }
              pasteBtn = document.getElementById('withdraw-paste-btn');
              if (pasteBtn) {
                pasteBtn.onmousedown = function (e) {
                  e.preventDefault();
                };
                pasteBtn.onclick = function (e) {
                  e.preventDefault();
                  e.stopPropagation();
                  void _this7.pasteAddress();
                };
              }
              scanBtn = document.getElementById('withdraw-qr-scan-btn');
              if (scanBtn) {
                scanBtn.onmousedown = function (e) {
                  e.preventDefault();
                };
                scanBtn.onclick = function (e) {
                  e.preventDefault();
                  e.stopPropagation();
                  _this7.scanAddress();
                };
              }
              feeWrap = document.getElementById('withdraw-fee-wrap');
              if (feeWrap) {
                feeWrap.onclick = function (e) {
                  e.preventDefault();
                  void _this7.promptForFee();
                };
              }
              txCopyBtn = document.getElementById('withdraw-confirm-tx-copy');
              if (txCopyBtn) {
                copyTxHash = function copyTxHash() {
                  void _this7.copyWithFeedback(txCopyBtn, _this7.lastTxHash);
                };
                txCopyBtn.onclick = copyTxHash;
                txCopyBtn.onkeydown = function (e) {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    copyTxHash();
                  }
                };
              }
              editBtn = document.getElementById('withdraw-edit');
              if (editBtn) {
                editBtn.onclick = function (e) {
                  e.preventDefault();
                  _this7.showComposeStep();
                };
              }
              tryEditBtn = document.getElementById('withdraw-try-edit');
              if (tryEditBtn) {
                tryEditBtn.onclick = function (e) {
                  e.preventDefault();
                  _this7.showComposeStep();
                };
              }
              tryAgainBtn = document.getElementById('withdraw-try-again');
              if (tryAgainBtn) {
                tryAgainBtn.onclick = function (e) {
                  var _document$getElementB0;
                  e.preventDefault();
                  _this7.resetConfirmPresentation();
                  _this7.setWithdrawState('review');
                  void ((_document$getElementB0 = document.getElementById('withdraw-confirm')) === null || _document$getElementB0 === void 0 ? void 0 : _document$getElementB0.click());
                };
              }
              explorerLink = document.getElementById('withdraw-confirm-tx-explorer');
              if (explorerLink) {
                explorerLink.onclick = function (e) {
                  if (!_this7.isNativeSaitoSelection()) {
                    e.preventDefault();
                    _this7.overlay.close();
                    _this7.app.connection.emit('saito-crypto-wallet-history-render-request', {
                      ticker: _this7.ticker
                    });
                    return;
                  }
                  _this7.overlay.close();
                };
              }
              form = document.querySelector('#withdrawal-form');
              if (form != null) {
                form.onsubmit = /*#__PURE__*/function () {
                  var _ref8 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12(e) {
                    var hasValidRecipient;
                    return _regenerator().w(function (_context12) {
                      while (1) switch (_context12.n) {
                        case 0:
                          e.preventDefault();
                          _context12.n = 1;
                          return _this7.updateAddressUiFromInput({
                            showError: true
                          });
                        case 1:
                          hasValidRecipient = _context12.v;
                          _this7.validateAmountInput();
                          _context12.n = 2;
                          return _this7.resolveRecipientPublicKey();
                        case 2:
                          if (!(!hasValidRecipient || !_this7.recipientAddressValid || _this7.errors['amount'] != false || _this7.errors['address'] != false)) {
                            _context12.n = 3;
                            break;
                          }
                          return _context12.a(2, false);
                        case 3:
                          if (!_this7.feePending) {
                            _context12.n = 4;
                            break;
                          }
                          return _context12.a(2, false);
                        case 4:
                          _context12.n = 5;
                          return _this7.sendWithdrawPayment();
                        case 5:
                          return _context12.a(2);
                      }
                    }, _callee12);
                  }));
                  return function (_x7) {
                    return _ref8.apply(this, arguments);
                  };
                }();
                confirmBtn = document.getElementById('withdraw-confirm');
                if (confirmBtn) {
                  confirmBtn.onclick = /*#__PURE__*/function () {
                    var _ref9 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee13(e) {
                      return _regenerator().w(function (_context13) {
                        while (1) switch (_context13.n) {
                          case 0:
                            e.preventDefault();
                            _context13.n = 1;
                            return _this7.sendWithdrawPayment();
                          case 1:
                            return _context13.a(2);
                        }
                      }, _callee13);
                    }));
                    return function (_x8) {
                      return _ref9.apply(this, arguments);
                    };
                  }();
                }
                maxBtn = document.getElementById('withdraw-max-btn');
                if (maxBtn != null) {
                  maxBtn.onclick = /*#__PURE__*/function () {
                    var _ref0 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee14(e) {
                      var _this_withdraw$pc, feePaidInSelectedAsset, fee;
                      return _regenerator().w(function (_context14) {
                        while (1) switch (_context14.n) {
                          case 0:
                            e.preventDefault();
                            if (document.querySelector('#withdraw-input-amount').disabled) {
                              _context14.n = 2;
                              break;
                            }
                            _context14.n = 1;
                            return this_withdraw.refreshAvailableBalanceDisplay();
                          case 1:
                            if (this_withdraw.isNftWithdrawSelection()) {
                              this_withdraw.setAmountInputValue(this_withdraw._nft_balance_raw != null ? this_withdraw._nft_balance_raw : this_withdraw.available_balance);
                            } else {
                              feePaidInSelectedAsset = !this_withdraw.feeAssetId || this_withdraw.feeAssetId === ((_this_withdraw$pc = this_withdraw.pc) === null || _this_withdraw$pc === void 0 ? void 0 : _this_withdraw$pc.asset_id);
                              fee = feePaidInSelectedAsset ? Number(this_withdraw.fee) || 0 : 0;
                              this_withdraw.setAmountInputValue(this_withdraw.available_balance - fee);
                            }
                            this_withdraw.validateAmountInput();
                            this_withdraw.updateAmountActionState();
                          case 2:
                            return _context14.a(2);
                        }
                      }, _callee14);
                    }));
                    return function (_x9) {
                      return _ref0.apply(this, arguments);
                    };
                  }();
                }
                if (document.getElementById('address-book')) {
                  document.getElementById('address-book').onclick = function (e) {
                    _this7.contacts.title = "Contacts with ".concat(_this7.ticker);
                    _this7.contacts.callback = /*#__PURE__*/function () {
                      var _ref1 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee15(key) {
                        var input, address;
                        return _regenerator().w(function (_context15) {
                          while (1) switch (_context15.n) {
                            case 0:
                              _this7.publicKey = key;
                              input = document.getElementById('withdraw-input-address');
                              if (!input) {
                                _context15.n = 3;
                                break;
                              }
                              address = key;
                              if (!(!_this7.isNativeSaitoSelection() && typeof _this7.pc.returnAddressFromPublicKey === 'function')) {
                                _context15.n = 2;
                                break;
                              }
                              _context15.n = 1;
                              return _this7.pc.returnAddressFromPublicKey(key);
                            case 1:
                              address = _context15.v;
                            case 2:
                              input.disabled = false;
                              input.value = address || '';
                            case 3:
                              _context15.n = 4;
                              return _this7.updateAddressUiFromInput({
                                showError: true
                              });
                            case 4:
                              _this7.clearAddressError();
                              _this7.handleErrors();
                            case 5:
                              return _context15.a(2);
                          }
                        }, _callee15);
                      }));
                      return function (_x0) {
                        return _ref1.apply(this, arguments);
                      };
                    }();
                    var contactsWithCrypto = _this7.app.keychain.returnKeys();
                    if (_this7.ticker !== 'SAITO') {
                      contactsWithCrypto = contactsWithCrypto.filter(function (k) {
                        return (k === null || k === void 0 ? void 0 : k.crypto_addresses) && k.crypto_addresses[_this7.ticker];
                      });
                    }
                    contactsWithCrypto = contactsWithCrypto.map(function (x) {
                      return x.publicKey;
                    });
                    _this7.contacts.render(contactsWithCrypto);
                  };
                }
                document.querySelectorAll('.saito-crypto-withdraw .withdraw-options-cont[role="button"]').forEach(function (control) {
                  control.onkeydown = function (e) {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      control.click();
                    }
                  };
                });
              }
            case 1:
              return _context16.a(2);
          }
        }, _callee16, this);
      }));
      function attachEvents() {
        return _attachEvents.apply(this, arguments);
      }
      return attachEvents;
    }()
  }, {
    key: "showError",
    value: function showError() {
      var detail = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var msgEl = document.getElementById('withdraw-send-result-message');
      if (msgEl) {
        msgEl.textContent = detail ? String(detail) : 'Please try again.';
      }
      this.setWithdrawState('failed');
      this.hideTxRow();
    }
  }, {
    key: "withdrawBroadcastSuccessUi",
    value: function withdrawBroadcastSuccessUi() {
      var _this$pc4;
      var hash = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      this.updateSuccessAction();
      this.setWithdrawState('success');
      if (hash && ((_this$pc4 = this.pc) === null || _this$pc4 === void 0 ? void 0 : _this$pc4.chain_id) === 'NATIVE') {
        this.showTxRow(hash);
      } else {
        this.hideTxRow();
      }
    }
  }, {
    key: "hideSaitoHeaderMenu",
    value: function hideSaitoHeaderMenu() {
      var components = this.mod.components;
      for (var key in components) {
        var _components$key;
        if (((_components$key = components[key]) === null || _components$key === void 0 ? void 0 : _components$key.slug) == 'SaitoHeader') {
          var saito_header = components[key];
          saito_header.hideMenu();
        }
      }
    }
  }, {
    key: "updateFeeEditability",
    value: function updateFeeEditability() {
      var _this$pc5;
      var wrap = document.getElementById('withdraw-fee-wrap');
      var isNative = ((_this$pc5 = this.pc) === null || _this$pc5 === void 0 ? void 0 : _this$pc5.chain_id) === 'NATIVE';
      wrap === null || wrap === void 0 || wrap.classList.toggle('fee-wrap--editable', isNative);
      if (wrap) {
        wrap.title = isNative ? 'Click to set the network fee' : '';
      }
    }
  }, {
    key: "promptForFee",
    value: function () {
      var _promptForFee = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee17() {
        var current, input, parsed, feeEl;
        return _regenerator().w(function (_context17) {
          while (1) switch (_context17.n) {
            case 0:
              if (!(!this.pc || this.pc.chain_id !== 'NATIVE')) {
                _context17.n = 1;
                break;
              }
              return _context17.a(2);
            case 1:
              current = this.getNativeDefaultFee().toString();
              _context17.n = 2;
              return sprompt('Set network fee (SAITO):', current);
            case 2:
              input = _context17.v;
              if (!(input === false || input === undefined || input === '')) {
                _context17.n = 3;
                break;
              }
              return _context17.a(2);
            case 3:
              parsed = parseFloat(input);
              if (!(!Number.isFinite(parsed) || parsed < 0)) {
                _context17.n = 4;
                break;
              }
              siteMessage('Please enter a valid, non-negative fee.', 2000);
              return _context17.a(2);
            case 4:
              this.app.options.wallet = this.app.options.wallet || {};
              this.app.options.wallet.default_fee = this.app.wallet.convertSaitoToNolan(parsed.toString());
              this.app.wallet.default_fee = BigInt(this.app.options.wallet.default_fee);
              this.app.storage.saveOptions();
              siteMessage("Network fee updated to: ".concat(parsed, " SAITO"), 1000);

              // Native-chain fee is a flat wallet setting, not dependent on the recipient
              // address, so reflect it immediately rather than waiting on fetchWithdrawFee's
              // address-gated lookup (which shows "--" until a valid address is entered).
              this.fee = parsed;
              feeEl = document.getElementById('withdraw-fee-display') || document.querySelector('.withdraw-info-value.fee');
              this.setFeeDisplayElement(feeEl, this.formatFeeDisplay(parsed));
              this.handleErrors();
              this.validateAmountInput();
            case 5:
              return _context17.a(2);
          }
        }, _callee17, this);
      }));
      function promptForFee() {
        return _promptForFee.apply(this, arguments);
      }
      return promptForFee;
    }()
  }, {
    key: "fetchWithdrawFee",
    value: function () {
      var _fetchWithdrawFee = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee19() {
        var _this$pc6,
          _document$getElementB1,
          _this$pc8,
          _this8 = this;
        var feeEl, _this$pc7, address, cryptoModule, requestKey, feeReceived, feeRequestPromise;
        return _regenerator().w(function (_context19) {
          while (1) switch (_context19.n) {
            case 0:
              feeEl = document.getElementById('withdraw-fee-display') || document.querySelector('.withdraw-info-value.fee');
              this.updateFeeEditability();
              if (feeEl) {
                _context19.n = 1;
                break;
              }
              return _context19.a(2);
            case 1:
              if (!(((_this$pc6 = this.pc) === null || _this$pc6 === void 0 ? void 0 : _this$pc6.chain_id) === 'NATIVE')) {
                _context19.n = 2;
                break;
              }
              this.feeRequestKey = '';
              this.feeRequestPromise = null;
              this.fee = this.getNativeDefaultFee();
              this.feeAssetId = ((_this$pc7 = this.pc) === null || _this$pc7 === void 0 ? void 0 : _this$pc7.asset_id) || '';
              this.feeTicker = '';
              this.feeAssetBalance = this.available_balance;
              this.feePending = false;
              this.setFeeDisplayElement(feeEl, this.formatFeeDisplay(this.fee));
              this.validateAmountInput();
              return _context19.a(2);
            case 2:
              address = ((_document$getElementB1 = document.getElementById('withdraw-input-address')) === null || _document$getElementB1 === void 0 || (_document$getElementB1 = _document$getElementB1.value) === null || _document$getElementB1 === void 0 ? void 0 : _document$getElementB1.trim()) || '';
              if (address) {
                _context19.n = 3;
                break;
              }
              this.feeRequestKey = '';
              this.feeRequestPromise = null;
              this.fee = null;
              this.feeAssetId = '';
              this.feeTicker = '';
              this.feeAssetBalance = null;
              this.feePending = false;
              this.setFeeDisplayElement(feeEl, '—', 'Add a recipient address to estimate the network fee');
              this.handleErrors();
              return _context19.a(2);
            case 3:
              if ((_this$pc8 = this.pc) !== null && _this$pc8 !== void 0 && _this$pc8.validateAddress(address)) {
                _context19.n = 4;
                break;
              }
              this.feeRequestKey = '';
              this.feeRequestPromise = null;
              this.fee = null;
              this.feeAssetId = '';
              this.feeTicker = '';
              this.feeAssetBalance = null;
              this.feePending = false;
              this.setFeeDisplayElement(feeEl, '—');
              this.handleErrors();
              return _context19.a(2);
            case 4:
              cryptoModule = this.pc;
              requestKey = "".concat(cryptoModule.ticker, ":").concat(address);
              if (!(this.feeRequestKey === requestKey && this.feeRequestPromise)) {
                _context19.n = 6;
                break;
              }
              _context19.n = 5;
              return this.feeRequestPromise;
            case 5:
              return _context19.a(2);
            case 6:
              this.address = address;
              this.feePending = true;
              this.feeRequestKey = requestKey;
              this.setFeeDisplayElement(feeEl, '…');
              this.handleErrors();
              feeReceived = false;
              feeRequestPromise = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee18() {
                var _t0;
                return _regenerator().w(function (_context18) {
                  while (1) switch (_context18.p = _context18.n) {
                    case 0:
                      _context18.p = 0;
                      _context18.n = 1;
                      return cryptoModule.checkWithdrawalFeeForAddress(address, function (amt) {
                        var feeDetails = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                        feeReceived = true;
                        if (_this8.feeRequestKey !== requestKey || _this8.pc !== cryptoModule) {
                          return;
                        }
                        _this8.fee = Number(amt);
                        _this8.feeAssetId = feeDetails.asset_id || cryptoModule.asset_id || '';
                        _this8.feeTicker = feeDetails.ticker || '';
                        _this8.feeAssetBalance = feeDetails.available_balance == null ? null : Number(feeDetails.available_balance);
                        _this8.feePending = false;
                        var feeTitle = _this8.feeAssetId && _this8.feeAssetId !== cryptoModule.asset_id ? "A ".concat(_this8.formatFeeTicker(), " balance is required to pay this network fee") : '';
                        _this8.setFeeDisplayElement(feeEl, _this8.formatFeeDisplay(amt), feeTitle);
                        _this8.validateAmountInput();
                      });
                    case 1:
                      if (!feeReceived && _this8.feeRequestKey === requestKey && _this8.pc === cryptoModule) {
                        _this8.fee = null;
                        _this8.feeAssetId = '';
                        _this8.feeTicker = '';
                        _this8.feeAssetBalance = null;
                        _this8.feePending = false;
                        _this8.setFeeDisplayElement(feeEl, '—', 'Unable to estimate the network fee');
                        _this8.handleErrors();
                      }
                      _context18.n = 3;
                      break;
                    case 2:
                      _context18.p = 2;
                      _t0 = _context18.v;
                      if (_this8.feeRequestKey === requestKey && _this8.pc === cryptoModule) {
                        _this8.fee = null;
                        _this8.feeAssetId = '';
                        _this8.feeTicker = '';
                        _this8.feeAssetBalance = null;
                        _this8.feePending = false;
                        _this8.setFeeDisplayElement(feeEl, '—', 'Unable to estimate the network fee');
                        _this8.handleErrors();
                      }
                      console.error('Withdraw: unable to estimate network fee', _t0);
                    case 3:
                      return _context18.a(2);
                  }
                }, _callee18, null, [[0, 2]]);
              }))();
              this.feeRequestPromise = feeRequestPromise;
              _context19.n = 7;
              return feeRequestPromise;
            case 7:
              if (this.feeRequestPromise === feeRequestPromise) {
                this.feeRequestKey = '';
                this.feeRequestPromise = null;
              }
            case 8:
              return _context19.a(2);
          }
        }, _callee19, this);
      }));
      function fetchWithdrawFee() {
        return _fetchWithdrawFee.apply(this, arguments);
      }
      return fetchWithdrawFee;
    }()
  }, {
    key: "validateAmountInput",
    value: function validateAmountInput() {
      var _input$value;
      this.clearAmountError();
      var input = document.getElementById('withdraw-input-amount');
      var hasInput = Boolean(input === null || input === void 0 || (_input$value = input.value) === null || _input$value === void 0 ? void 0 : _input$value.trim());
      var amount = this.getAmountInputValue();
      var error_msg = null;
      if (!hasInput) {
        this.updateAmountActionState();
        this.handleErrors();
        return;
      }
      if (amount != '') {
        if (this.isNftWithdrawSelection()) {
          var amtStr = String(amount).trim();
          try {
            var want = BigInt(amtStr);
            var avail = this._nft_balance_raw != null && this._nft_balance_raw !== '' ? BigInt(this._nft_balance_raw) : BigInt(Math.floor(Number(this.available_balance) || 0));
            if (want <= 0n) {
              error_msg = 'Amount must be greater than 0';
            } else if (want > avail) {
              error_msg = "Insufficient NFT units (".concat(avail.toString(), " ").concat(this.ticker, " available)");
            }
          } catch (e) {
            error_msg = 'Enter a whole number of NFT units';
          }
        } else {
          var _this$pc9;
          amount = Number(amount);
          var amount_avl = this.available_balance;
          this.fee = Number(this.fee);
          var feePaidInSelectedAsset = !this.feeAssetId || this.feeAssetId === ((_this$pc9 = this.pc) === null || _this$pc9 === void 0 ? void 0 : _this$pc9.asset_id);
          if (amount <= 0) {
            error_msg = 'Amount must be greater than 0';
          } else if (amount > amount_avl) {
            error_msg = "Insufficient funds (".concat(amount_avl, " ").concat(this.ticker, " available)");
          } else if (feePaidInSelectedAsset && Number.isFinite(this.fee) && amount + this.fee > amount_avl) {
            error_msg = 'The amount plus the network fee exceeds your available balance';
          } else if (!feePaidInSelectedAsset && Number.isFinite(this.fee) && Number.isFinite(this.feeAssetBalance) && this.feeAssetBalance < this.fee) {
            error_msg = "A ".concat(this.formatFeeTicker(), " balance is required to move ").concat(this.ticker, ". ") + "The network fee is ".concat(this.fee, " ").concat(this.formatFeeTicker(), ", but only ") + "".concat(this.feeAssetBalance, " ").concat(this.formatFeeTicker(), " is available.");
          }
        }
      } else {
        error_msg = 'Enter a valid amount';
      }
      if (error_msg) {
        this.errors['amount'] = true;
        this.amountErrorMessage = error_msg;
      }
      this.updateAmountActionState();
      this.handleErrors();
    }
  }, {
    key: "validateAddressInput",
    value: function validateAddressInput() {
      var _document$querySelect;
      this.clearAddressError();
      this.address = ((_document$querySelect = document.querySelector('#withdraw-input-address')) === null || _document$querySelect === void 0 || (_document$querySelect = _document$querySelect.value) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.trim()) || '';
      var valid = this.pc.validateAddress(this.address);
      this.recipientAddressValid = valid;
      if (!valid) {
        this.errors['address'] = true;
        this.address = '';
        this.renderInvalidRecipientPreview();
        this.showAddressPreview();
      }
      this.handleErrors();
    }
  }, {
    key: "handleErrors",
    value: function handleErrors() {
      var submit = document.querySelector('#saito-overlay-submit');
      if (!submit) {
        return;
      }
      var blocked = this.errors['amount'] != false || this.errors['address'] != false || this.feePending || !this.recipientAddressValid || !this.hasAmountInputValue();
      if (blocked) {
        if (!submit.getAttribute('disabled')) {
          submit.setAttribute('disabled', true);
        }
      } else {
        submit.removeAttribute('disabled');
      }
    }
  }, {
    key: "clearAddressError",
    value: function clearAddressError() {
      this.errors['address'] = false;
    }
  }, {
    key: "clearAmountError",
    value: function clearAmountError() {
      this.errors['amount'] = false;
      this.amountErrorMessage = '';
    }
  }, {
    key: "resetErrors",
    value: function resetErrors() {
      this.errors = {
        amount: false,
        address: false
      };
      this.clearAddressError();
      this.clearAmountError();
      this.recipientAddressValid = false;
      this.handleErrors();
    }
  }, {
    key: "isNftWithdrawSelection",
    value: function isNftWithdrawSelection() {
      var _this$pc0, _this$pc1;
      return ((_this$pc0 = this.pc) === null || _this$pc0 === void 0 ? void 0 : _this$pc0.categories) === 'NFT' && typeof ((_this$pc1 = this.pc) === null || _this$pc1 === void 0 ? void 0 : _this$pc1.nft_id) === 'string' && this.pc.nft_id;
    }
  }, {
    key: "clear",
    value: function clear() {
      this.closeTokenMenu();
      this.resetErrors();
      this.ticker = null;
      this.pc = null;
      this.publicKey = '';
      this.fixedRecipient = false;
      this.address = '';
      this.recipientAddressValid = false;
      this.fee = null;
      this.feeAssetId = '';
      this.feeTicker = '';
      this.feeAssetBalance = null;
      this.feePending = false;
      this.feeRequestKey = '';
      this.feeRequestPromise = null;
      this.lastTxHash = '';
      this.available_balance = 0;
      this._nft_balance_raw = null;
      this.amountErrorMessage = '';
    }
  }]);
}();
module.exports = Withdraw;